import type { FC } from "react";
import { PlaybookEditorLoadingState } from "./playbookEditorLoadingState.js";
import { usePlaybookEditorOutletContext } from "./playbookEditorOutletContext.js";
import { PlaybookSettingsTab } from "./playbookSettingsTab.js";

export const PlaybookSettingsPage: FC = () => {
  const context = usePlaybookEditorOutletContext();
  const { data, onChange, showsKnowledgeBase } = context;

  return (
    <div className="min-h-0 flex-1 overflow-y-auto">
      {data ? (
        <PlaybookSettingsTab
          data={data}
          onChange={onChange}
          showsKnowledgeBase={showsKnowledgeBase}
        />
      ) : (
        <PlaybookEditorLoadingState />
      )}
    </div>
  );
};
